// extracted by mini-css-extract-plugin
export default {"actionsHeaderWrapper":"ColumnEditor_actionsHeaderWrapper__szSNT"};